<template>
  <v-col>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="localtranslation.name"
          :readonly="currentRouteName === 'forms.show'"
          :rules="rules.requiredTextLine65"
          :counter="65"
          :label="`${$t('ITEM.NAME')}` + requiredStr"
        ></v-text-field>
      </v-col>
    </v-row>
  </v-col>
</template>
<script>
import { cloneDeep } from 'lodash';
import { requiredTextLine65 } from '@/modules/_global/variables/rules.js';

export default {
  name: 'FormForm',

  model: {
    prop: 'translation'
  },

  props: {
    translation: {
      type: Object,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    requiredStr: ' *',
    valid: true,
    localtranslation: {},
    rules: {
      requiredTextLine65
    }
  }),

  computed: {
    currentRouteName() {
      return this.$route.name;
    }
  },
  watch: {
    localtranslation: {
      deep: true,
      handler: 'setTranslation'
    },
    translation: {
      deep: true,
      handler() {
        if (
          JSON.stringify(this.translation) ===
          JSON.stringify(this.localtranslation)
        ) {
          return;
        }
        this.setData();
      }
    }
  },
  created() {
    this.setData();
  },

  methods: {
    setData() {
      this.localtranslation = cloneDeep(this.translation);
    },
    setTranslation() {
      this.$emit('input', Object.assign({}, this.localtranslation));
    }
  }
};
</script>
